import { i18n } from '@/plugins/i18n'

export const SEPSciencePoData = () => ({
  subPopulation: 'sciencePo',
  periods: {
    year: 'dormitoryPeriod-year-may',
    autumn: 'dormitoryPeriod-autumn-january',
    spring: 'dormitoryPeriod-spring-february-may',
  },
  periodOfStay: {
    valid: false,
    period: null,
  },
  contactDetails: {
    valid: false,
    address: '',
    birthday: '',
    birthLocation: '',
    city: '',
    country: '',
    firstName: '',
    lastName: '',
    mail: '',
    nationality: '',
    sex: '',
    titleOther: '',
    titleClassName: '',
    titleClassDate: '',
    zipCode: '',
  },
  registration: {
    valid: false,
    originEntity: '',
    registrationFaculty: 'IEP Strasbourg',
    registrationPersuedDegree: '',
    titleOther: '',
    exchangeProgram: '',
  },
  accommodation: {
    mui: false,
    muiChoice1: '',
    muiChoice2: '',
    muiChoice3: '',
    choiceCrous: false,
    crousRoomChoices: {
      choice1: '',
      choice2: '',
      choice3: '',
      choice4: '',
      choice5: '',
      choice6: '',
      choice7: '',
    },
    crousRoomList: [
      {
        value: 'housingWeiss',
        text: i18n.t('accommodation.crousRoomList.housingWeiss'),
      },
      {
        value: 'housingCattleyas',
        text: i18n.t('accommodation.crousRoomList.housingCattleyas'),
      },
      // {
      //   value: 'housingAppell9',
      //   text: i18n.t('accommodation.crousRoomList.housingAppell9'),
      // },
      {
        value: 'housingAppell10',
        text: i18n.t('accommodation.crousRoomList.housingAppell10'),
      },
      /*          {
                  value: 'housingAgapanthes',
                  text: i18n.t('accommodation.crousRoomList.housingAgapanthes'),
                },*/
      // {
      //   value: 'housingSomme',
      //   text: i18n.t('accommodation.crousRoomList.housingSomme'),
      // },
      /*          {
                  value: 'housingRobertsau',
                  text: i18n.t('accommodation.crousRoomList.housingRobertsau'),
                },*/
      {
        value: 'housingFlamboyants',
        text: i18n.t('accommodation.crousRoomList.housingFlamboyants'),
      },
      {
        value: 'housingGallia12',
        text: i18n.t('accommodation.crousRoomList.housingGallia12'),
      },
    ],
  },
  moreInformation: {
    valid: false,
    arrivalDate: null,
    informationMessage: '',
  },
  authorization: {
    valid: false,
    muiAuthorizationChecker: false,
    legalNoticeDormitory: false,
    legalNoticeCROUS: false,
  },
})
export const SEPOtherData = () => ({
  subPopulation: 'other',
  periods: {
    year: 'dormitoryPeriod-year-june',
    autumn: 'dormitoryPeriod-autumn-january',
    spring: 'dormitoryPeriod-spring-february-june',
  },
  periodOfStay: {
    valid: false,
    period: null,
  },
  contactDetails: {
    valid: false,
    address: '',
    birthday: '',
    birthLocation: '',
    city: '',
    country: '',
    firstName: '',
    lastName: '',
    mail: '',
    nationality: '',
    sex: '',
    titleOther: '',
    titleClassName: '',
    titleClassDate: '',
    zipCode: '',
  },
  registration: {
    valid: false,
    originEntity: '',
    registrationFaculty: '',
    registrationPersuedDegree: '',
    titleOther: '',
    exchangeProgram: '',
  },
  accommodation: {
    mui: false,
    muiChoice1: '',
    muiChoice2: '',
    muiChoice3: '',
    choiceCrous: false,
    crousRoomChoices: {
      choice1: '',
      choice2: '',
      choice3: '',
      choice4: '',
      choice5: '',
      choice6: '',
      choice7: '',
      choice8: '',
      choice9: '',
      choice10: '',
    },
    crousRoomList: [
      {
        value: 'housingWeiss',
        text: i18n.t('accommodation.crousRoomList.housingWeiss'),
      },
      {
        value: 'housingWeiss18',
        text: i18n.t('accommodation.crousRoomList.housingWeiss18'),
      },
      {
        value: 'housingCattleyas',
        text: i18n.t('accommodation.crousRoomList.housingCattleyas'),
      },
      // {
      //   value: 'housingAppell9',
      //   text: i18n.t('accommodation.crousRoomList.housingAppell9'),
      // },
      {
        value: 'housingAppell10',
        text: i18n.t('accommodation.crousRoomList.housingAppell10'),
      },
      {
        value: 'housingAgapanthes',
        text: i18n.t('accommodation.crousRoomList.housingAgapanthes'),
      },
      // {
      //   value: 'housingSomme',
      //   text: i18n.t('accommodation.crousRoomList.housingSomme'),
      // },
      {
        value: 'housingRobertsau',
        text: i18n.t('accommodation.crousRoomList.housingRobertsau'),
      },
      {
        value: 'housingFlamboyants',
        text: i18n.t('accommodation.crousRoomList.housingFlamboyants'),
      },
      {
        value: 'housingBruckhof',
        text: i18n.t('accommodation.crousRoomList.housingBruckhof'),
      },
      {
        value: 'housingGallia20',
        text: i18n.t('accommodation.crousRoomList.housingGallia20'),
      },
    ],
  },
  moreInformation: {
    valid: false,
    arrivalDate: null,
    informationMessage: '',
  },
  authorization: {
    valid: false,
    muiAuthorizationChecker: false,
    legalNoticeDormitory: false,
    legalNoticeCROUS: false,
  },
})
export const SEPIutData = () => ({
  subPopulation: 'iut',
  periods: {
    year: 'dormitoryPeriod-year-june',
    autumn: 'dormitoryPeriod-autumn-january',
    spring: 'dormitoryPeriod-spring-february-june',
  },
  periodOfStay: {
    valid: false,
    period: null,
  },
  contactDetails: {
    valid: false,
    address: '',
    birthday: '',
    birthLocation: '',
    city: '',
    country: '',
    firstName: '',
    lastName: '',
    mail: '',
    nationality: '',
    sex: '',
    titleOther: '',
    titleClassName: '',
    titleClassDate: '',
    zipCode: '',
  },
  registration: {
    valid: false,
    originEntity: '',
    registrationFaculty: 'IUT Robert SCHUMAN',
    registrationPersuedDegree: '',
    titleOther: '',
    exchangeProgram: '',
  },
  accommodation: {
    mui: false,
    muiChoice1: '',
    muiChoice2: '',
    muiChoice3: '',
    choiceCrous: false,
    crousRoomChoices: {
      choice1: '',
      choice2: '',
    },
    crousRoomList: [
      {
        value: 'housingWeiss',
        text: i18n.t('accommodation.crousRoomList.housingWeiss'),
      },
      {
        value: 'housingCattleyas',
        text: i18n.t('accommodation.crousRoomList.housingCattleyas'),
      },
    ],
  },
  moreInformation: {
    valid: false,
    arrivalDate: null,
    informationMessage: '',
  },
  authorization: {
    valid: false,
    muiAuthorizationChecker: false,
    legalNoticeDormitory: false,
    legalNoticeCROUS: false,
  },
})
export const SEPEMData = () => ({
  subPopulation: 'em',
  periods: {
    year: 'dormitoryPeriod-year-april',
    autumn: 'dormitoryPeriod-autumn-december',
    spring: 'dormitoryPeriod-spring-january-april',
  },
  periodOfStay: {
    valid: false,
    period: true,
  },
  contactDetails: {
    valid: false,
    address: '',
    birthday: '',
    birthLocation: '',
    city: '',
    country: '',
    firstName: '',
    lastName: '',
    mail: '',
    nationality: '',
    sex: '',
    titleOther: '',
    titleClassName: '',
    titleClassDate: '',
    zipCode: '',
  },
  registration: {
    valid: false,
    originEntity: '',
    registrationFaculty: 'EM Strasbourg',
    registrationPersuedDegree: '',
    titleOther: '',
    exchangeProgram: '',
  },
  accommodation: {
    mui: false,
    muiChoice1: '',
    muiChoice2: '',
    muiChoice3: '',
    choiceCrous: false,
    crousRoomChoices: {
      choice1: '',
      choice2: '',
      choice3: '',
      choice4: '',
      choice5: '',
      choice6: '',
      choice7: '',
    },
    crousRoomList: [
      {
        value: 'housingWeiss',
        text: i18n.t('accommodation.crousRoomList.housingWeiss'),
      },
      {
        value: 'housingCattleyas',
        text: i18n.t('accommodation.crousRoomList.housingCattleyas'),
      },
      // {
      //   value: 'housingAppell9',
      //   text: i18n.t('accommodation.crousRoomList.housingAppell9'),
      // },
      {
        value: 'housingAppell10',
        text: i18n.t('accommodation.crousRoomList.housingAppell10'),
      },
      {
        value: 'housingAgapanthes',
        text: i18n.t('accommodation.crousRoomList.housingAgapanthes'),
      },
      // {
      //   value: 'housingSomme',
      //   text: i18n.t('accommodation.crousRoomList.housingSomme'),
      // },
      {
        value: 'housingRobertsau',
        text: i18n.t('accommodation.crousRoomList.housingRobertsau'),
      },
    ],
  },
  moreInformation: {
    valid: false,
    arrivalDate: null,
    informationMessage: '',
  },
  authorization: {
    valid: false,
    muiAuthorizationChecker: false,
    legalNoticeDormitory: false,
    legalNoticeCROUS: false,
  },
})
export const SEPLaw = () => ({
  subPopulation: 'law',
  periods: {
    year: 'dormitoryPeriod-year-may',
    autumn: 'dormitoryPeriod-autumn-january',
    spring: 'dormitoryPeriod-spring-february-may',
  },
  periodOfStay: {
    valid: false,
    period: true,
  },
  contactDetails: {
    valid: false,
    address: '',
    birthday: '',
    birthLocation: '',
    city: '',
    country: '',
    firstName: '',
    lastName: '',
    mail: '',
    nationality: '',
    sex: '',
    titleOther: '',
    titleClassName: '',
    titleClassDate: '',
    zipCode: '',
  },
  registration: {
    valid: false,
    originEntity: '',
    registrationFaculty: 'Faculté de Droit, de Sciences Politiques et de Gestion',
    registrationPersuedDegree: '',
    titleOther: '',
    exchangeProgram: '',
  },
  accommodation: {
    mui: false,
    muiChoice1: '',
    muiChoice2: '',
    muiChoice3: '',
    choiceCrous: false,
    crousRoomChoices: {
      choice1: '',
      choice2: '',
      choice3: '',
      choice4: '',
      choice5: '',
    },
    crousRoomList: [
      {
        value: 'housingWeiss',
        text: i18n.t('accommodation.crousRoomList.housingWeiss'),
      },
      {
        value: 'housingCattleyas',
        text: i18n.t('accommodation.crousRoomList.housingCattleyas'),
      },
      // {
      //   value: 'housingAppell9',
      //   text: i18n.t('accommodation.crousRoomList.housingAppell9'),
      // },
      {
        value: 'housingAppell10',
        text: i18n.t('accommodation.crousRoomList.housingAppell10'),
      },
      {
        value: 'housingFlamboyants',
        text: i18n.t('accommodation.crousRoomList.housingAgapanthes'),
      },
      // {
      //   value: 'housingSomme',
      //   text: i18n.t('accommodation.crousRoomList.housingSomme'),
      // },
    ],
  },
  moreInformation: {
    valid: false,
    arrivalDate: null,
    informationMessage: '',
  },
  authorization: {
    valid: false,
    muiAuthorizationChecker: false,
    legalNoticeDormitory: false,
    legalNoticeCROUS: false,
  },
})
export const ResearcherData = () => ({
  datesOfStay: {
    valid: false,
    arrivalDate: null,
    departureDate: null,
  },
  contactDetails: {
    valid: false,
    address: '',
    birthday: '',
    birthLocation: '',
    city: '',
    country: '',
    firstName: '',
    lastName: '',
    mail: '',
    nationality: '',
    phone: '',
    sex: '',
    status: '',
    statusItems: [
      {
        text: i18n.t('contactDetails.status.items.visitingScholar'),
        value: 'visitingScholar',
      },
      {
        text: i18n.t('contactDetails.status.items.postDoc'),
        value: 'postDoc',
      },
      {
        text: i18n.t('contactDetails.status.items.guestLecturer'),
        value: 'guestLecturer',
      },
      {
        text: i18n.t('contactDetails.status.items.other'),
        value: 'other',
      },
    ],
    titleOther: '',
    zipCode: '',
  },
  registration: {
    valid: false,
    registrationAddress: '',
    registrationEmail: '',
    registrationEntity: '',
    registrationManager: '',
    registrationPhone: '',
    registrationReferent: '',
  },
  accommodation: {
    valid: false,
    arconati: false,
    arconatiChoice: '',
    mui: false,
    muiChoice1: '',
    muiChoice2: '',
    muiChoice3: '',
  },
  moreInformation: {
    informationMessage: '',
    informationNumber: '',
    informationNumberAdults: '',
    informationNumberChildren: '',
    informationPayment: '',
  },
  authorization: {
    valid: false,
    authorizationChecker: false,
  },
})
export const PHDData = () => ({
  datesOfStay: {
    valid: false,
    arrivalDate: null,
    departureDate: null,
  },
  contactDetails: {
    valid: false,
    address: '',
    birthday: '',
    birthLocation: '',
    city: '',
    country: '',
    firstName: '',
    lastName: '',
    mail: '',
    nationality: '',
    phone: '',
    sex: '',
    status: '',
    statusItems: [
      {
        text: i18n.t('contactDetails.status.items.phdStudentCDE'),
        value: 'phdStudentCDE',
      },
      {
        text: i18n.t('contactDetails.status.items.phdStudentIDEX'),
        value: 'phdStudentIDEX',
      },
      {
        text: i18n.t('contactDetails.status.items.coPhd'),
        value: 'coPhd',
      },
      {
        text: i18n.t('contactDetails.status.items.phdStudent'),
        value: 'phdStudent',
      },
      {
        text: i18n.t('contactDetails.status.items.other'),
        value: 'other',
      },
    ],
    titleOther: '',
    titleClassName: '',
    titleClassDate: '',
    zipCode: '',
  },
  registration: {
    valid: false,
    registrationAddress: '',
    registrationEmail: '',
    registrationEntity: '',
    registrationEntitiesList: [
      {
        text: i18n.t('registration.registrationEntitiesList.ed221'),
        value: 'ed221',
      },
      {
        text: i18n.t('registration.registrationEntitiesList.ed101'),
        value: 'ed101',
      },
      {
        text: i18n.t('registration.registrationEntitiesList.ed520'),
        value: 'ed520',
      },
      {
        text: i18n.t('registration.registrationEntitiesList.ed269'),
        value: 'ed269',
      },
      {
        text: i18n.t('registration.registrationEntitiesList.ed182'),
        value: 'ed182',
      },
      {
        text: i18n.t('registration.registrationEntitiesList.ed222'),
        value: 'ed222',
      },
      {
        text: i18n.t('registration.registrationEntitiesList.ed519'),
        value: 'ed519',
      },
      {
        text: i18n.t('registration.registrationEntitiesList.ed413'),
        value: 'ed413',
      },
      {
        text: i18n.t('registration.registrationEntitiesList.ed414'),
        value: 'ed414',
      },
      {
        text: i18n.t('registration.registrationEntitiesList.ed270'),
        value: 'ed270',
      },
    ],
    registrationManager: '',
    registrationPhone: '',
    registrationReferent: '',
  },
  accommodation: {
    doctoral: false,
    mui: false,
    muiChoice1: '',
    muiChoice2: '',
    muiChoice3: '',
  },
  moreInformation: {
    informationMessage: '',
    informationNumber: '',
    informationNumberAdults: '',
    informationPayment: '',
  },
  authorization: {
    valid: false,
    muiAuthorizationChecker: false,
    doctoralAuthorizationChecker: false,
  },
})
